import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const COOKIE_CONSENT_KEY = "cookie_consent";

export function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-description"
      className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border shadow-lg animate-fade-in"
    >
      <div className="container py-4 md:py-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <h2 id="cookie-consent-title" className="font-display font-bold text-secondary mb-1">
              Cookie Preferences
            </h2>
            <p id="cookie-consent-description" className="text-sm text-muted-foreground">
              We use cookies to improve your experience on our website. Essential cookies are necessary for the site to function. 
              You can read more in our{" "}
              <Link to="/cookies" className="text-primary hover:underline">
                Cookie Policy
              </Link>.
            </p>
          </div>
          <div className="flex gap-3">
            <Button
              variant="outline"
              onClick={handleDecline}
              className="border-secondary text-secondary hover:bg-secondary hover:text-secondary-foreground"
            >
              Decline
            </Button>
            <Button
              onClick={handleAccept}
              className="bg-gradient-hero shadow-button hover:shadow-lg"
            >
              Accept
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}